import { api, API } from "./_apiClient";

// Authenticated file download. On iOS native (Capacitor), <a download> is
// blocked by WKWebView — we save to Documents + open the native Share
// Sheet instead. Web falls back to the classic anchor click.
export async function downloadBlob(url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const { isNative } = await import("./platform");

  if (isNative()) {
    const { Filesystem, Directory } = await import("@capacitor/filesystem");
    const { Share } = await import("@capacitor/share");

    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(reader.error);
      reader.onload = () => {
        const result = reader.result || "";
        const idx = result.indexOf(",");
        resolve(idx >= 0 ? result.slice(idx + 1) : result);
      };
      reader.readAsDataURL(res.data);
    });

    const written = await Filesystem.writeFile({
      path: filename,
      data: base64,
      directory: Directory.Cache,
      recursive: true,
    });

    await Share.share({
      title: filename,
      url: written.uri,
      dialogTitle: "حفظ الوثيقة",
    }).catch(() => { /* user dismissed — not an error */ });
    return;
  }

  // Web fallback — classic anchor download
  const blobUrl = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
}

// Re-export API for callers that used to import it from `./api`.
export { API };
